import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/sle/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/sle/';

class SaleService {
  /*getAll() {
    return axios.get(API_URL + `sales/all`, { headers: authHeader() });
  }*/

  getAll(page, pageSize) {
    //return axios.get(API_URL + `sales/${page}/${pageSize}/all`, { headers: authHeader() } );
    return axios.get(API_URL + `sales/all?page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `sales/${id}`, { headers: authHeader() });
  }

  create(sale) {
    return axios.post(API_URL + `sales/cre`, {
      pv: sale.pv,
      quantity: sale.quantity,
      totalPv: sale.totalPv,
      receiptNo: sale.receiptNo,
      soldDate: sale.soldDate,
      memberId: sale.memberId,
      productId: sale.productId
    }, { headers: authHeader() });
  }

  update(id, sale) {
    return axios.put(API_URL + `sales/${id}/upd`, {
      id: sale.id,  
      pv: sale.pv,
      quantity: sale.quantity,
      totalPv: sale.totalPv,
      soldDate: sale.soldDate,
      memberId: sale.memberId,
      productId: sale.productId
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  /*getBySoldDate(soldDate) {
    return axios.get(API_URL + `all?soldDate=${soldDate}`, { headers: authHeader() });
  }*/
  getSalesByDate(startDate, endDate, page, pageSize) {
    return axios.get(API_URL + `sales/${startDate}/${endDate}/${page}/${pageSize}/date`, { headers: authHeader() });
  }

  getSalesByMember(memberId) {
    return axios.get(API_URL + `sales/${memberId}/member`, { headers: authHeader() });
  }

  getSalesAndProductsByMember(memberId) {
    return axios.get(API_URL + `sales/${memberId}/salesandproducts`, { headers: authHeader() });
  }

  getSalesByProduct(productId) {
    return axios.get(API_URL + `sales/${productId}/product`, { headers: authHeader() });
  }

  getTotalPpv(memberId, month, year) {
    return axios.get(API_URL + `sales/${memberId}/${month}/${year}/totalppv`, { headers: authHeader() });
  }

  getTotalNdc(sponsor, month, year) {
    return axios.get(API_URL + `sales/${sponsor}/${month}/${year}/totalndc`, { headers: authHeader() });
  }

  getMonthlyPpv(memberId, month, year) {
    return axios.get(API_URL + `sales/${memberId}/${month}/${year}/monthlyppv`, { headers: authHeader() });
  }

  getMonthlyNdc(sponsor, month, year) {
    return axios.get(API_URL + `sales/${sponsor}/${month}/${year}/monthlyndc`, { headers: authHeader() });
  }

  getPaidAmount(memberId, maDate) {
    return axios.get(API_URL + `sales/${memberId}/${maDate}/paidamount`, { headers: authHeader() });
  }

  getPaidAmountByMemberMonthAndYear(memberId, month, year) {
    return axios.get(API_URL + `sales/${memberId}/${month}/${year}/paidamountbymembermonthandyear`, { headers: authHeader() });
  }

  getTotalBonus(memberId, month, year) {
    return axios.get(API_URL + `sales/${memberId}/${month}/${year}/totalbonus`, { headers: authHeader() });
  }

  calculateMembersBonus(month, year) {
    return axios.get(API_URL + `sales/${month}/${year}/calculatemembersbonus`, { headers: authHeader() });
  }

  getTotalSales() {
    return axios.get(API_URL + `sales/totalsales`, { headers: authHeader() });
  }

  getTotalSalesByDate(startDate, endDate) {
    return axios.get(API_URL + `sales/${startDate}/${endDate}/totalsalesbydate`, { headers: authHeader() });
  }

  getTotalSalesByMemberId(memberId) {
    return axios.get(API_URL + `sales/${memberId}/totalsalesbymemberid`, { headers: authHeader() });
  }

  getSalesByMemberIdPageable(memberId, page, pageSize) {
    return axios.get(API_URL + `sales/salesbymempageable?memberId=${memberId}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }
  
}

export default new SaleService();